import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import EmptyStates from '../../../../common/components/empty-states';
import { useSelector } from '../../../../common/components/runtime-context';
import {
  MY_POSTS_PAGE_TAB_DRAFTS,
  MY_POSTS_PAGE_TAB_PUBLICATIONS,
  MY_POSTS_PAGE_TAB_SUBMISSIONS,
} from '../../../constants/my-posts-page';
import { getActiveTab } from '../../../store/active-tab/active-tab-selectors';
import styles from './no-posts.scss';

const NoPosts = () => {
  const activeTab = useSelector(getActiveTab);
  const { t } = useTranslation();

  const activeTabTexts = {
    [MY_POSTS_PAGE_TAB_PUBLICATIONS]: {
      title: t('no-publications.title'),
      content: t('no-publications.content'),
    },
    [MY_POSTS_PAGE_TAB_SUBMISSIONS]: {
      title: t('no-submissions.title'),
      content: t('no-submissions.content'),
    },
    [MY_POSTS_PAGE_TAB_DRAFTS]: {
      title: t('no-drafts.title'),
      content: t('no-drafts.content'),
    },
  };

  const { title, content } = activeTabTexts[activeTab as keyof typeof activeTabTexts];

  return <EmptyStates className={styles.root} title={title} content={content} />;
};

export default NoPosts;
